<template>
  <div :class="'wap-header'+(isFixed?'':' header-boxs')" :style="{'background-color':isFixed?'':'#19203B'}">
    <img class="logo" @click="to_page('/')" src="@/assets/imgs/common/logo.png" />

    <img class="right-icon" src="@/assets/imgs/wap/20.png" @click="navigationShow=true"  />
    <template v-if="navigationShow">
      <navigation @close="navigationShow=false"></navigation>
    </template>

  </div>
</template>

<script>
  import navigation from "./navigation";
  export default {
    name: 'wapHeader',
    components:{navigation},
    data(){
      return{
        isFixed:false,
        navigationShow:false
      }
    },
    mounted() {
      window.addEventListener('scroll',this.handleScroll)
    },
    methods: {
      handleScroll(){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
        this.isFixed = scrollTop > 80 ? false : true; // 如果滚动到顶部了，this.isFixed就为true
      },
      to_page(path){
        this.$router.push({
          path:path
        })
      },
    },
  }
</script>
<style scoped>

  .wap-header{
    display: flex;
    justify-content: space-between;
    padding: 0.2rem 0.68rem;
    position: fixed;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    z-index: 9999 ;
  }
  .wap-header .logo{
    width: 2.6rem;
    height: 0.72rem;
  }

  .wap-header .right-icon{
    width: 0.56rem;
    height: 0.56rem;
    object-fit: cover;
  }
  .header-boxs{
    transition: all 1500ms ease;
  }
</style>



// WEBPACK FOOTER //
// src/components/wap/header1.vue